import { Box, Heading, Body, Container, BoxProps } from '@hover/blueprint';
import React from 'react';
import { useInterSectionObserver } from '../../../hooks';

interface Props extends BoxProps {
  setCurrentTool?: React.Dispatch<React.SetStateAction<number>> | null;
  header: string;
  body: string;
  toolNumber: number;
}

const ToolDescription: React.FC<Props> = ({
  setCurrentTool,
  header,
  body,
  toolNumber,
  ...restProps
}) => {
  const firstToolRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting && !!setCurrentTool) {
        setCurrentTool(toolNumber);
      }
    },
    {
      rootMargin: '0px',
      root: null,
      threshold: 0.5,
    },
  );

  return (
    <Box
      pl={{ base: 0, desktop: 700 }}
      ref={firstToolRef.elementRef}
      h={{ base: 'auto', desktop: '100vh' }}
      flexDir="column"
      alignItems="flex-start"
      justifyContent="center"
      {...restProps}
    >
      <Heading marginBottom={{ base: 500, desktop: 200 }} size={600} isLight>
        {header}
      </Heading>
      <Container px={200}>
        <Body size={500} marginBottom={{ base: 500, desktop: 200 }}>
          {body}
        </Body>
      </Container>
    </Box>
  );
};

ToolDescription.defaultProps = {
  setCurrentTool: null,
};

export default ToolDescription;
